"use strict";import{Theme as e}from"../Theme.js";import m from"./theme.css.js";e.registerThemeFragment("spectrum-two","system",m);
//# sourceMappingURL=core.js.map
